import React, { useState, useEffect } from 'react';
import './TipoClienteForm.css';

const TipoClienteForm = ({ tipoCliente, isEditing, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    nome: '',
    servicos: [],
    ativo: true
  });

  useEffect(() => {
    if (tipoCliente && isEditing) {
      setFormData({
        nome: tipoCliente.nome || '',
        servicos: tipoCliente.servicos || [],
        ativo: tipoCliente.ativo !== undefined ? tipoCliente.ativo : true
      });
    }
  }, [tipoCliente, isEditing]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleAddServico = () => {
    setFormData(prev => ({
      ...prev,
      servicos: [...prev.servicos, { nome: '', valor: 0 }]
    }));
  };

  const handleRemoveServico = (index) => {
    setFormData(prev => ({
      ...prev,
      servicos: prev.servicos.filter((_, i) => i !== index)
    }));
  };

  const handleServicoChange = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      servicos: prev.servicos.map((servico, i) => 
        i === index 
          ? { ...servico, [field]: field === 'valor' ? parseFloat(value) || 0 : value }
          : servico
      )
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.nome.trim()) {
      alert('Por favor, preencha o nome do tipo de cliente');
      return;
    }

    // Validate services
    for (const servico of formData.servicos) {
      if (!servico.nome.trim()) {
        alert('Por favor, preencha o nome de todos os serviços');
        return;
      }
      if (servico.valor < 0) {
        alert('O valor do serviço não pode ser negativo');
        return;
      }
    }

    onSubmit(formData);
  };

  return (
    <form className="tipo-cliente-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="nome">Nome do Tipo de Cliente *</label>
        <input
          type="text"
          id="nome"
          name="nome"
          className="form-control"
          value={formData.nome}
          onChange={handleInputChange}
          placeholder="Ex: Cliente Premium"
          required
        />
      </div>

      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            name="ativo"
            checked={formData.ativo}
            onChange={handleInputChange}
          />
          <span>Ativo</span>
        </label>
      </div>

      <div className="servicos-section">
        <div className="servicos-header">
          <h3>Serviços</h3>
          <button 
            type="button" 
            className="add-servico-btn"
            onClick={handleAddServico}
          >
            <span>+</span> Adicionar Serviço
          </button>
        </div>

        {formData.servicos.length === 0 ? (
          <p className="no-servicos-message">
            Nenhum serviço adicionado. Clique no botão acima para adicionar.
          </p>
        ) : (
          <div className="servicos-list">
            {formData.servicos.map((servico, index) => (
              <div key={index} className="servico-item">
                <div className="servico-fields">
                  <div className="form-group">
                    <label>Tipo de Serviço</label>
                    <input
                      type="text"
                      className="form-control"
                      value={servico.nome}
                      onChange={(e) => handleServicoChange(index, 'nome', e.target.value)}
                      placeholder="Ex: Consultoria"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Valor (R$)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={servico.valor}
                      onChange={(e) => handleServicoChange(index, 'valor', e.target.value)}
                      placeholder="0.00"
                      min="0"
                      step="0.01"
                      required
                    />
                  </div>
                </div>
                <button
                  type="button"
                  className="remove-servico-btn"
                  onClick={() => handleRemoveServico(index)}
                  title="Remover serviço"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="form-actions">
        <button type="button" className="btn-cancel" onClick={onCancel}>
          Cancelar
        </button>
        <button type="submit" className="btn-submit">
          {isEditing ? 'Salvar Alterações' : 'Cadastrar'}
        </button>
      </div>
    </form>
  );
};

export default TipoClienteForm;
